import styled from "styled-components";

export const RiWra = styled.div`
  direction: rtl;
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  padding: 40px;

  @media screen and (max-width: 760px) {
    padding: 20px;
  }
`;
export const RiCon = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  word-wrap: anywhere;
  line-height: 18px;
  word-break: break-word;

  @media screen and (max-width: 760px) {
  }
`;
export const RiHe = styled.h1`
  color: rgba(0, 111, 185);
  font-family: Raleway;
  font-size: 30px;
  line-height: 44px;
  text-align: center;
  margin-bottom: 1rem;

  @media screen and (max-width: 760px) {
    font-size: 26px;
  }
`;
export const RiPa = styled.p`
  margin-bottom: 10px;
  font-size: 20px;
  letter-spacing: 0.16px;
  line-height: 24px;
  text-align: right;
  color: rgba(68, 68, 68);
  font-family: Helvetica Now Text Regular;

  @media screen and (max-width: 760px) {
  }
`;
export const RiHea = styled.h5`
  color: rgba(0, 111, 185);
  font-family: Raleway;
  font-family: Helvetica Now Display Bold;
  font-size: 20px;
  line-height: 20px;
  margin-bottom: 12px;

  @media screen and (max-width: 760px) {
  }
`;
export const RiUl = styled.ul`
  margin-bottom: 20px;
  font-size: 16px;
  letter-spacing: 0.16px;
  line-height: 24px;
  text-align: right;
  color: rgba(68, 68, 68);
  font-family: Helvetica Now Text Regular;

  @media screen and (max-width: 760px) {
  }
`;
